import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from '../../../business-entities/brand.model';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { ImageService } from '../../../services/image.service';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model'
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { PreferenceModel } from '../../../business-entities/preferences-model';
import { BaseService } from '../../../../../../Autofacets-Core/src/app/services/base.service';
import { PromotionBusinessService } from '../../../business-services/promotion.service';
import { CategoryService } from '../../../business-services/category.service';
import { Categories } from '../../../business-entities/category-list-model';
import { EditPromotion, PromotionModel } from '../../../business-entities/promotions-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerHolidayBusinessService } from '../../../business-services/dealer-holiday.service';
import { Observable } from 'rxjs/internal/Observable';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-edit-promotions',
  templateUrl: './edit-promotions.component.html'
 
})
export class EditPromotionsComponent implements OnInit {
  isValidDate = true;
  curentYear: number = new Date().getFullYear();
  AnswerList = Array(1);
  editPreference = false;
  editPreferenceForm: FormGroup;
  editPromotionForm: FormGroup;
  brandList: Brand[] = [];
  categoryList: Categories[] = [];
  brand: Brand[];
  category: Categories[]
  id: number;
  language: string;
  image: string | ArrayBuffer;
  PreferenceModel: PreferenceModel;
  PromotionModel: PromotionModel
  dealerList: SelectListItemViewModel[];
  editedPromotion: EditPromotion = {
    categoryId: null,
    brandId: null,
    promotionDescription: "",
    description: "",
    updatedBy: "",
    imageBinaryData: "",
    mimeType: "",
    image: "",
    promotionImage: "",
    originalPrice: null,
    startDate: null,
    endDate:null,
    isMultipleAllowed: false,
    quantity: null,
    offerPrice: null,
    offerStartDate: null,
    offerEndDate: null
  };
  selectedDealer:any[]=[];
  selectedDealerId: string;
  dealerId: string;
  dealerSelected: {value:string, text:string}[] = [];
  startDate: string;
  endDate: string;
  offerStartDate: string;
  offerEndDate: string;
  isMaxAnswer: boolean = false
  answers: string
  imageBaseData: string | ArrayBuffer = null;
  allLanguage: any[];
  vehicleTypes: VehicleType[] = [];
  multipleAnsweroptions: FormArray
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private getAllCategoryData: CategoryService,
    public dealerHolidayBusinessService: DealerHolidayBusinessService,
    private promotionService: PromotionBusinessService,
    private spinner: NgxSpinnerService,
    private baseService: BaseService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cdr: ChangeDetectorRef,
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private imageService: ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.editPromotionForm = this.formBuilder.group({
      category: [null, [Validators.required]],
      dealer: ['', [Validators.required]],
      promotionNames: new FormArray([]),
      categoryNames: new FormArray([]),
      promotionDescription: new FormArray([]),
      startDate: [''],
      endDate: [''],
      originalPrice: [''],
      offerStartDate: [null, [Validators.required]],
      offerEndDate: [null, [Validators.required]],
      offerPrice: [''],
      isAllowedMultiple: [false],
      quantity: [''],
      image: [''],
      isActive: ['']
    });
    this.getBrandData();
    this.getPromotionLanguage();
    this.getCategoryLanguage();
    this.GetAllVehicleTypes();
    this.editPromotionForm.controls.dealer.disable();
    this.editPromotionForm.controls.categoryNames.disable();
  }

  get p() { return this.cpf.promotionNames as FormArray; }
  get t() { return this.cpf.promotionDescription as FormArray; }

  getPromotionLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.p.length < number) {
      for (let i = this.p.length; i < number; i++) {
        this.p.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.p.length; i >= number; i--) {
        this.p.removeAt(i);
      }
    }
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }

  get c() { return this.cpf.categoryNames as FormArray; }

  getCategoryLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if (localStorage.getItem("Theme") == Constant.BnhInterface) {
        this.vehicleTypes = data.responseObject;
      }
      else {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }
  async getBrandData() {
    this.id = this.promotionService.PromotionId
    await this.GetAllBrand();
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.language = x
      this.getPromotion(this.id);
    });
  }
  setDealer(event: NgbTypeaheadSelectItemEvent) {
    event.preventDefault();
    this.selectedDealerId = event.item.value;
    this.dealerSelected = event.item.text;
}
  get cpf() {
    return this.editPromotionForm.controls;
  }

  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  async GetAllCategories() {
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.language = x
    })
    await this.getAllCategoryData.getCategoryList(this.language).then(data => {
      this.category = data;
      for (let value of this.category) {
        this.categoryList.push(value)
      }
    })
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.editedPromotion.mimeType = files[0].type;
    this.editedPromotion.image = files[0].name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_readerEvent) => {
      this.PromotionModel.promotionDetails.imagePath = "";
      me.imageBaseData = reader.result;
      this.editedPromotion.imageBinaryData = reader.result.toString().replace('data:' + this.editedPromotion.mimeType + ';base64,', '');
      this.editedPromotion.promotionImage = me.imageBaseData;
      this.image = me.imageBaseData;
    };
    reader.onerror = function (_error) {
      // This is intentional
    };

  }

  async getPromotion(id: number) {
    this.spinner.show();
    await this.promotionService.getPromotionById(id).then(result => {
      if (result) {
        this.PromotionModel = result.responseObject;
        
        this.image = this.PromotionModel.promotionDetails.promotionImage === null ? './../../../assets/images/no-img.png' : this.PromotionModel.promotionDetails.imagePath
        this.editPromotionForm.controls["dealer"].setValue(this.PromotionModel.promotionDetails.dealer);
        this.editPromotionForm.patchValue({
          ...result.responseObject
          // vehicletype: this.PreferenceModel.specialToolDetails.vehicleType
        })
      }
    })
    this.spinner.hide();
  }

  formatter = (result: SelectListItemViewModel) => result.text.toUpperCase();

  search = (text$: Observable<string>) =>
      text$.pipe(
          debounceTime(200),
          distinctUntilChanged(),
          map(term => {
              return term === '' ? []
                  : this.dealerList.filter(v => v.text.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
          })
      )

  handleResultSelected(result) {
      this.search = result;
  }


  async setDealerDetails() {
    let selectedDealerId = this.dealerHolidayBusinessService.dealerId;
    if (selectedDealerId && selectedDealerId !== '') {
         await this.onDropdownDealerSelected(selectedDealerId)
    }
  }

  onDropdownDealerSelected(dealerId: any): void {
    if (dealerId == null) {
      this.selectedDealer = [];
      this.selectedDealerId='';
    } else {
      if (dealerId.length == 0) {
        this.selectedDealer= [];
        this.selectedDealerId=''
      }
      else
      {
        let dealerIdValue='';
        dealerId.forEach(element => {
            dealerIdValue +=element.value + ','
        });
        this.selectedDealerId=dealerIdValue;
      }
    }
  }

  convertDate(d: any) {
    let parts = d.split(" ");
    let months = { Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06", Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12" };
    return parts[3] + "-" + months[parts[1]] + "-" + parts[2];
}

validateDates(sDate: string, eDate: string) {
    if (sDate == null || eDate == null) {
        this.toastr.error(Constant.DateValidation);
        return !this.isValidDate;
    }

    if (eDate < sDate) {
        this.toastr.error(Constant.DateRangeValidation);
        return !this.isValidDate;
    }
    return this.isValidDate;
}

validateDateTime(startDate:Date,endDate:Date)
{
    if(endDate<startDate)
    {
        this.toastr.error(Constant.DateRangeValidation);
        return !this.isValidDate;
    }
    return this.isValidDate;
}

  editPromotions() {
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    let endDate = (this.editPromotionForm.value.endDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.editPromotionForm.value.endDate)):null;
    let startDate = (this.editPromotionForm.value.startDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.editPromotionForm.value.startDate)):null;
    let offerEndDate = (this.editPromotionForm.value.offerEndDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.editPromotionForm.value.offerEndDate)):null;
    let offerStartDate = (this.editPromotionForm.value.offerStartDate)?Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.editPromotionForm.value.offerStartDate)):null;
    const viewModel = {
      ...this.editPromotionForm.value,
      image: this.editedPromotion.image,
      startDate: startDate,
      endDate: endDate,
      offerEndDate: offerEndDate,
      offerStartDate: offerStartDate,
      mimeType: this.editedPromotion.mimeType,
      imageBinaryData: this.editedPromotion.imageBinaryData,
      updatedBy: currentUser,
      dealerId: this.PromotionModel.promotionDetails.dealerId,
      dealerList: this.dealerSelected,
      categoryId: this.PromotionModel.promotionDetails.categoryId,
      id: this.PromotionModel.promotionDetails.id
    }
    const isValidFormat = this.imageService.validateImageFormat(this.editedPromotion.mimeType);
    if (isValidFormat) {
      this.promotionService.addEditPromotion(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          let successmsg = this.translate.instant("lblPromotionsUpdated");
          this.toastr.success(successmsg);
          this.spinner.hide();
          this.activeModal.close({ success: true });
        }
        else if (res.responseObject === false) {
          this.spinner.hide();
          let errormsg = this.translate.instant("lblPromotionExists");
          this.toastr.warning(errormsg);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toastr.error(imageErr)
    }
    this.spinner.hide();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  OnClose() {
    this.activeModal.close({success:false})
  }
}
